module.exports = __webpack_public_path__ + "img/sam2.0090c4cc.jpg";